import React, { useEffect, useState } from 'react';
import { INVESTIGATION_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import SearchEntity from '../Controls/SearchEntitiy';
import { getUserState } from '../utils';
import EntityData from './InvestigationComponents/EntityData/EntityData';
import EntityStatistics from './InvestigationComponents/EntityStatistics/EntityStatistics';
import EntityActivities from './InvestigationComponents/EntityActivities/EntityActivities';
import queryString from 'query-string';
import styles from './InvestigationLayout.module.css';
import { useTowerLayout } from '../../TowerLayout/TowerLayoutProvider';

const InvestigationLayout = ({ match, location }) => {
    const [showLoader, setShowLoader] = useState(true);
    const [userData, setUserData] = useState({});
    const [entityId, setEntityId] = useState(null);
    const { setLayoutContent } = useTowerLayout();

    const findEntityType = () => {
        const investigationEntitiesTypes = [
            INVESTIGATION_ENTITY_TYPES.USER,
            INVESTIGATION_ENTITY_TYPES.RESOURCE,
            INVESTIGATION_ENTITY_TYPES.OKTA,
            INVESTIGATION_ENTITY_TYPES.APPLICATION
        ];

        for (const type of investigationEntitiesTypes) {
            if (match.path.startsWith(type.urlPrefix)) return type;
        }
    };

    const entityType = findEntityType();
    const entityGuid = match.params.guid;
    const queryParams = queryString.parse(location.search);

    useEffect(() => {
        async function loadUserData() {
            try {
                const userData = await getUserState();
                setUserData(userData);
            } catch (err) {
                console.error(err);
            }
            setShowLoader(false);
        }
        loadUserData();
    }, []);

    useEffect(() => {
        const layoutData = (
            <span className={`search-entity-layout`}>
                <SearchEntity user={userData.user} />
            </span>
        );
        setLayoutContent(layoutData);
        return () => setLayoutContent('');
    }, [setLayoutContent, userData]);

    return (
        <div id="entityPage" className={'light-scrollbar'}>
            {showLoader && (
                <div className="silverfort-loader">
                    <div className="logo"></div>
                </div>
            )}
            <div className={styles.warper}>
                <div className={styles.warperContent}>
                    <div className={styles.upSide}>
                        <EntityData
                            entityGuid={entityGuid}
                            displayName={queryParams.displayName}
                            entityType={entityType}
                            setEntityId={setEntityId}
                            user={userData.user}
                        />

                        <EntityStatistics entityGuid={entityGuid} entityId={entityId} entityType={entityType} />
                    </div>
                    <div>
                        <EntityActivities
                            entityGuid={entityGuid}
                            entityId={entityId}
                            entityType={entityType}
                            user={userData}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvestigationLayout;
